<template>
<svg viewBox="0 0 14 14" :fill="useCurrentColor ? 'currentColor' : '#000'" xmlns="http://www.w3.org/2000/svg" :class="[`${prefix}-icon`, `${prefix}-icon-fill-output`]" width="1em" height="1em" v-bind="$attrs"><path d="M5.6001 1.59375C6.83446 1.59383 7.96553 2.03485 8.84521 2.76758C8.7966 2.76578 8.74778 2.76367 8.69873 2.76367C6.54265 2.76367 4.79457 4.51192 4.79443 6.66797C4.79443 8.82413 6.54256 10.5723 8.69873 10.5723C8.74779 10.5723 8.79659 10.5702 8.84521 10.5684C7.96549 11.3012 6.83458 11.7431 5.6001 11.7432C2.79744 11.7432 0.524902 9.47063 0.524902 6.66797C0.525045 3.86543 2.79753 1.59375 5.6001 1.59375ZM9.90283 4.375C10.0886 4.36662 10.3314 4.55871 10.8179 4.94141L12.2153 6.04004C12.4875 6.25419 12.6241 6.36131 12.6733 6.49121C12.7164 6.60515 12.7164 6.73178 12.6733 6.8457C12.624 6.97546 12.4873 7.08288 12.2153 7.29688L10.8179 8.39551C10.3316 8.77807 10.0885 8.9703 9.90283 8.96191C9.74184 8.95454 9.59416 8.8695 9.50635 8.73438C9.40511 8.57843 9.44664 8.27131 9.53076 7.6582L9.56592 7.40137H6.96729C6.56255 7.40115 6.23406 7.07271 6.23389 6.66797C6.23413 6.26329 6.5626 5.93576 6.96729 5.93555H9.56592L9.53076 5.67871C9.44667 5.06577 9.40534 4.75861 9.50635 4.60254C9.59414 4.46733 9.74179 4.38239 9.90283 4.375Z"/></svg>
</template>
<script>

export default {
  name: 'IconFillOutput',
  props: {
    prefix: {
        type: String,
        default: 'sc',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
